export default __webpack_public_path__ + "static/media/LogOut.e5aa15db.svg";